import React from 'react'
import { Badge, IconButton } from '@mui/material'
import { Visibility } from '@mui/icons-material'
import { putAwayActions } from '../../actions/putAwayActions'
import { usePutAway } from '../../Context/usePutAway'
import { FlipBackOptions } from '../../types/enums'

export default function FlipButtonFront() {
  const { state } = usePutAway()
  const { isFlipped: flippState, workOrderSkuHistory } = state
  const { handleFlipGetHistory } = putAwayActions()

  return (
    <IconButton
      onClick={() => handleFlipGetHistory(FlipBackOptions.LocateHistory)}
      style={{
        zIndex: 1,
        alignSelf: 'flex-start',
        padding: '15px',
        visibility: flippState.isFlipped ? 'hidden' : 'visible'
      }}
      color='primary'
    >
      <Badge
        color='secondary'
        badgeContent={workOrderSkuHistory.length}
        invisible={workOrderSkuHistory.length === 0}
      >
        <Visibility />
      </Badge>
    </IconButton>
  )
}
